// Import all endpoint files to trigger injectEndpoints registration.
import "@/modules/contacts/store/services/endpoints/get-contacts";
import "@/modules/contacts/store/services/endpoints/get-draft-contacts";
import "@/modules/contacts/store/services/endpoints/import-draft-contacts";
import "@/modules/contacts/store/services/endpoints/update-draft-contacts";

// Re-export all generated hooks.
export { useGetContactsQuery } from "@/modules/contacts/store/services/endpoints/get-contacts";
export { useGetDraftContactsQuery } from "@/modules/contacts/store/services/endpoints/get-draft-contacts";
export { useImportDraftContactsMutation } from "@/modules/contacts/store/services/endpoints/import-draft-contacts";
export { useUpdateDraftContactsMutation } from "@/modules/contacts/store/services/endpoints/update-draft-contacts";

